module.exports = __webpack_public_path__ + "img/activity.563875a3.png";